export default "__VITE_ASSET__CZzfH2px__"